import classNames from 'classnames';
import PropTypes from 'prop-types';

import ImagePreview from 'components/App/ImagePreview';
import styles from './DiscoverPlaceInformation.module.scss';

function InfoCell({ label, value }) {
  return (
    <div className={styles.InfoCell}>
      <span className={styles.InfoLabel}>{label}</span>
      <span className={styles.InfoValue}>{value || 'N/A'}</span>
    </div>
  );
}

InfoCell.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
};

InfoCell.defaultProps = {
  value: '',
};

function DiscoverPlaceInformation({
  name,
  address,
  description,
  serviceHours,
  priceRange,
  phone,
  category,
  contactName,
  contactEmail,
  createdAt,
  mainImage,
  images,
}) {
  return (
    <div className={styles.Component}>
      <div className={classNames(styles.Row, 'align-items-center')}>
        {mainImage && (
          <div className={styles.Thumbnail}>
            <img
              alt="preview"
              src={mainImage}
              className={styles.ThumbnailImage}
            />
          </div>
        )}

        <div className={styles.RowContent}>
          <h2 className={styles.Name}>{name || 'Chưa có tên'}</h2>
          <p className={styles.Address}>{address || 'Chưa có địa chỉ'}</p>
        </div>
      </div>

      <div className={classNames(styles.Row, 'flex-column gap-2')}>
        <div className={styles.RowTitle}>Mô tả</div>
        <div className={styles.Description}>
          {description ? (
            <p>{description}</p>
          ) : (
            <p className={styles.EmptyText}>Chưa có mô tả</p>
          )}
        </div>
      </div>

      <div className={styles.Row}>
        <InfoCell label="Giờ phục vụ" value={serviceHours} />
        <InfoCell label="Khoảng giá" value={priceRange} />
        <InfoCell label="Thông tin liên lạc" value={phone} />
        {category && <InfoCell label="Hạng mục" value={category} />}
      </div>

      <div className={classNames(styles.Row, 'mb-0')} style={{ borderBottom: 'none' }}>
        <InfoCell label="Tên người liên hệ" value={contactName} />
        <InfoCell label="Địa chỉ Email" value={contactEmail} />
        <InfoCell label="Ngày tạo" value={createdAt} />
        {category && <div className={styles.InfoCell} />}
      </div>

      <div className={classNames(styles.Row, 'flex-column gap-2')}>
        <div className={styles.RowTitle}>Hình ảnh</div>
        <div className={styles.ImagePreview}>
          <ImagePreview
            images={images.map((image) => image.image || image)}
            size={100}
          />
        </div>
        {/* <div className={styles.ImageGallery}>
          {images && images.length > 0 ? (
            images.map((image, index) => (
              <div key={image.id || index} className={styles.ImageItem}>
                <LazyLoadImage
                  alt={`preview-${index}`}
                  effect="blur"
                  src={image.image || image}
                  className={styles.GalleryImage}
                />
              </div>
            ))
          ) : (
            <p className={styles.EmptyText}>Chưa có hình ảnh</p>
          )}
        </div> */}
      </div>
    </div>
  );
}

DiscoverPlaceInformation.propTypes = {
  name: PropTypes.string,
  address: PropTypes.string,
  description: PropTypes.string,
  serviceHours: PropTypes.string,
  priceRange: PropTypes.string,
  phone: PropTypes.string,
  category: PropTypes.string,
  contactName: PropTypes.string,
  contactEmail: PropTypes.string,
  createdAt: PropTypes.string,
  mainImage: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        image: PropTypes.string,
      }),
    ]),
  ),
};

DiscoverPlaceInformation.defaultProps = {
  name: '',
  address: '',
  description: '',
  serviceHours: '',
  priceRange: '',
  phone: '',
  category: '',
  contactName: '',
  contactEmail: '',
  createdAt: '',
  mainImage: '',
  images: [],
};

export default DiscoverPlaceInformation;
